import React, { useState } from "react";
import img2 from "../../assets/Gallery/img2.jpeg";
import img6 from "../../assets/Gallery/img6.jpeg";
import img7 from "../../assets/Gallery/img7.jpeg";
import img5 from "../../assets/Gallery/img5.jpeg";
import img3 from "../../assets/Gallery/img3.jpeg";
import img14 from "../../assets/Gallery/img14.jpeg";
import img13 from "../../assets/Gallery/img13.jpeg";
import img11 from "../../assets/Gallery/img11.jpeg";
import img12 from "../../assets/Gallery/img12.jpeg";
import img15 from "../../assets/Gallery/img15.jpeg";
import img4 from "../../assets/Gallery/img4.png";
import img8 from "../../assets/Gallery/img8.jpeg";
import img9 from "../../assets/Gallery/img9.jpeg";
import img1 from "../../assets/Gallery/img1.jpeg";
import "./Gallery.css";
import { useMediaQuery, useTheme } from "@mui/material";
import { NextArrow, PrevArrow } from "../Team/TeamCarousel";
import styles from "../About/About.module.css";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
const Gallery = () => {
  const [index, setIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const images = [
    img12,
    img11,
    img13,
    img14,
    img9,
    img8,
    img15,
    img1,
    img3,
    img6,
    img5,
    img4,
    img2,
  ];
  //plant lab farmer rest
  const onNextClick = () => {
    if (index == images.length - 1) {
      setIndex(0);
    } else {
      setIndex((index) => index + 1);
    }
  };

  const onPrevClick = () => {
    if (index == 0) {
      setIndex(images.length - 1);
    } else {
      setIndex((index) => index - 1);
    }
  };
  return (
    <section
      style={{
        ...(isMobile && {
          padding: "0px",
        }),
      }}
      className={styles.container}
      id="gallery"
    >
      {/* <div className={styles.textwithlines}>
        <div className={styles.line}></div>
        <h2 className={styles.title}>Gallery</h2>
        <div className={styles.line}></div>
      </div> */}
      <div className="mobile-gallery">
        <div className="prev-button-wrapper">
          <button
            style={{
              border: "none",
            }}
            onClick={onPrevClick}
          >
            <KeyboardArrowLeftIcon
            // style={{
            //   backgroundColor: "white",
            //   borderRadius: "50%",
            //   fill: "lightgray",
            //   height: "20px",
            //   width: "20px",
            //   opacity:"0.75"
            // }}
            />
          </button>
        </div>

        <div className="images-wrapper">
          {/* {images.map((img) => {
            return (
              <div className="image-wrapper">
                <img src={img}></img>
              </div>
            );
          })} */}
          <img
            className={isMobile ? "mobile-img" : ""}
            src={images[index]}
          ></img>
        </div>

        <div className="next-button-wrapper">
          <button onClick={onNextClick}>
            <KeyboardArrowRightIcon />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
